import { render, staticRenderFns } from "./CapituloCuatroPage.vue?vue&type=template&id=cc883518"
import script from "./CapituloCuatroPage.js?vue&type=script&lang=js&external"
export * from "./CapituloCuatroPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports